import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';

import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';

// BuyerMatchHint: Hinweis in der Akquise, wenn für das Objekt des Eigentümers ein Käufer vorgemerkt ist (Matching 14.10.2026) –
// ein starkes Argument im Gespräch. Der Käufer bleibt intern (keine Namen nennen).
export function BuyerMatchHint({ leadId }: { leadId: string }) {
  const { project } = useProject();
  const papi = useProjectApi();
  const q = useQuery({
    queryKey: projectKeys.leadBuyerMatches(project.id, leadId),
    queryFn: ({ signal }) => papi.leadBuyerMatches(leadId, signal),
    staleTime: 5 * 60_000,
  });
  const items = q.data?.items ?? [];
  const first = items[0];
  if (!first) return null;
  return (
    <p className="alert alert-info buyer-hint">
      <strong>{items.length === 1 ? 'Ein Käufer ist vorgemerkt' : `${items.length} Käufer sind vorgemerkt`}</strong> – sucht {first.profile}
      {items.length > 1 ? ' u. a.' : ''}. Gutes Argument im Gespräch: „Wir haben einen Kaufinteressenten, der genau so etwas sucht.“ Den Käufer nicht
      namentlich nennen.{' '}
      <Link to={`/p/${project.key}/kaufgesuche?id=${first.request_id}`}>Kaufgesuch ansehen</Link>
    </p>
  );
}
